import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import HeroImg from '../assets/bg-header.jpg';
import HowItWorks from "../components/HowItWorks";
import LessonsCards from "../components/LessonsCards";

interface Event {
  name: string;
  desc?: string;
  link: string;
  date?: string;
  month: string;
  spotMessage?: string;
  isBookable: boolean;
}

const events: Event[] = [
  /*{ date: "06.09", name: "Forehand Focus", link: "#", month: "September 2025", isBookable: true },
  { date: "13.09", name: "Flat Serve Focus", link: "#", month: "September 2025", isBookable: false },
  { date: "20.09", name: "Spin Serve Focus", link: "#", month: "September 2025", isBookable: true },
  { date: "27.09", name: "Serve Combination Focus", link: "#", month: "September 2025", isBookable: true },
  { date: "04.10", name: "Forehand Focus", link: "#", month: "October 2025", isBookable: true },
  { date: "11.10", name: "Flat Serve Focus", link: "#", month: "October 2025", isBookable: false },
  { date: "18.10", name: "Spin Serve Focus", link: "#", month: "October 2025", isBookable: true },
  { date: "25.10", name: "Serve Combination Focus", link: "#", month: "October 2025", isBookable: true },
  { date: "01.11", name: "Backhand Focus", link: "#", month: "November 2025", isBookable: true },
  { date: "08.11", name: "Flat Serve Focus", link: "#", month: "November 2025", isBookable: true },
  { date: "15.11", name: "Spin Serve Focus", link: "#", month: "November 2025", isBookable: true },
  { date: "22.11", name: "Serve Combination Focus", link: "#", month: "November 2025", isBookable: true },
  { date: "29.11", name: "Forehand Focus", link: "#", month: "November 2025", isBookable: true },
  { date: "13.12", name: "Flat Serve Focus", link: "#", month: "December 2025", isBookable: true },
  { date: "20.12", name: "Spin Serve Focus", link: "#", month: "December 2025", isBookable: true },*/
  { date: "2.5", name: "Flat Serve Clinic", link: "#", month: "May 2026", isBookable: true },
  { date: "9.5", name: "Spin Serve Clinic", link: "#", month: "May 2026", isBookable: true },
  { date: "16.5", name: "Flat Serve Clinic", link: "#", month: "May 2026", isBookable: true },
  { date: "23.5", name: "Spin Serve Clinic", link: "#", month: "May 2026", isBookable: true },
  { date: "30.5", name: "Serve Combination Clinic", link: "#", month: "May 2026", isBookable: true },
];

const ClinicItem = ({ event }: { event: Event }) => {
  const [showModal, setShowModal] = useState(false);

  const handleBooking = () => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const message = `Hello Alain, I would like to confirm my booking for the tennis clinic - ${event.name} | ${event.date}`;
    const phoneNumber = "358407339282";
    const url = isMobile
      ? `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`
      : `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
    window.location.href = url;
  };

  return (
    <>
      <div className={`relative p-6 rounded-3xl border transition-all duration-300 flex flex-col justify-between ${event.isBookable ? 'bg-white border-gray-100 shadow-lg hover:shadow-2xl' : 'bg-gray-100 border-gray-200 opacity-75'
        }`}>
        <div>
          <div className="flex justify-between items-start mb-4">
            {event.isBookable ? (
              <span className="px-3 py-1 bg-primary/10 text-primary text-xs font-bold rounded-full uppercase tracking-wider">
                Max 3 players
              </span>
            ) : (
              <span className="px-3 py-1 bg-red-100 text-red-600 text-xs font-bold rounded-full uppercase tracking-wider">
                Fully Booked
              </span>
            )}
            <span className="text-gray-400 font-medium text-sm">{event.date}</span>
          </div>
          <h4 className="text-xl font-bold text-navy mb-2 leading-tight">{event.name}</h4>
        </div>

        {event.isBookable && (
          <button
            onClick={() => setShowModal(true)}
            className="mt-6 btn-premium bg-primary text-white hover:bg-primary-dark py-2 text-sm w-full"
          >
            Book Now
          </button>
        )}
      </div>

      {showModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-fade-in">
          <div className="bg-white rounded-3xl max-w-lg w-full p-8 shadow-2xl relative overflow-hidden">
            <div className="absolute top-0 right-0 w-32 h-32 bg-primary/5 -mr-16 -mt-16 rounded-full" />
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-4 right-4 p-2 text-gray-400 hover:text-navy transition-colors"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            </button>
            <h3 className="text-2xl font-bold text-navy mb-6">{event.name}</h3>
            <div className="space-y-4 text-gray-600 mb-8 leading-relaxed">
              <p>Please follow the booking instructions below to confirm your place:</p>
              <ul className="space-y-3 pl-4 list-disc marker:text-primary">
                <li>Contact Coach Alain via WhatsApp or Phone at <span className="font-bold text-navy">+358 407 339 282</span></li>
                <li>Spots are strictly limited to <span className="font-bold text-navy italic">3 players</span> per clinic.</li>
                <li>Secure your booking early to avoid disappointment.</li>
              </ul>
            </div>
            <button
              onClick={handleBooking}
              className="btn-premium bg-primary text-white w-full shadow-lg shadow-primary/20"
            >
              WhatsApp Alain to Confirm
            </button>
          </div>
        </div>
      )}
    </>
  );
};

const CourseDetails = () => {
  const { state } = useLocation();
  const { targetId } = state || {};

  useEffect(() => {
    if (targetId) {
      const el = document.getElementById(targetId);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  }, [targetId]);

  const groupedEvents: Record<string, Event[]> = events.reduce((acc: any, event) => {
    if (!acc[event.month]) acc[event.month] = [];
    acc[event.month].push(event);
    return acc;
  }, {});

  const monthBgColors: Record<number, string> = {
    0: 'bg-white',
    1: 'bg-gray-50',
    2: 'bg-white',
    3: 'bg-gray-50',
  };

  return (
    <div className="max-w-7xl mx-auto px-6 py-24">
      <div className="mb-16">
        <h2 className="text-4xl md:text-5xl font-extrabold text-navy mb-6">Pre-Summer Clinics</h2>
        <div className="w-24 h-1.5 bg-primary rounded-full mb-8" />
        <div className="glass-card p-8 border-l-8 border-l-primary">
          <p className="text-xl text-gray-700 leading-relaxed max-w-4xl">
            Our intensive <span className="font-bold text-primary">Pre-Summer clinic</span> focuses on the technical precision of the serve - power, placement, and consistency.
            The clinic starts from <span className="font-bold text-primary">May 02, 2026</span>.
            All clinics are held at <span className="font-bold text-navy">Tali Tenniskeskus, Helsinki</span>.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-24">
        <div className="p-8 bg-green-50 rounded-3xl border border-green-100">
          <h4 className="text-lg font-bold text-green-800 mb-3 uppercase tracking-wider">Focus Areas</h4>
          <ul className="space-y-2 text-green-900 font-medium italic">
            <li>• Technical Analysis</li>
            <li>• Implementation Drills</li>
            <li>• Tactical Performance</li>
          </ul>
        </div>
        <div className="p-8 bg-blue-50 rounded-3xl border border-blue-100">
          <h4 className="text-lg font-bold text-blue-800 mb-3 uppercase tracking-wider">Video Analysis</h4>
          <p className="text-blue-900 font-medium italic leading-relaxed">
            Personalized video feedback is available upon request during all clinic sessions.
          </p>
        </div>
        <div className="p-8 bg-orange-50 rounded-3xl border border-orange-100">
          <h4 className="text-lg font-bold text-orange-800 mb-3 uppercase tracking-wider">Private Coaching</h4>
          <p className="text-orange-900 font-medium italic leading-relaxed">
            Reach out via WhatsApp or email (alainbrouillaud@mac.com) for private 1-on-1 bookings.
          </p>
        </div>
      </div>

      {Object.keys(groupedEvents).map((month, idx) => (
        <div key={month} className={`py-16 px-8 rounded-[3rem] mb-12 ${monthBgColors[idx]}`}>
          <h3 className="text-3xl font-black text-navy mb-10 pl-4 border-l-4 border-primary capitalize">{month}</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {groupedEvents[month].map((event, i) => (
              <ClinicItem key={`${month}-${i}`} event={event} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default function Courses() {
  return (
    <main className="font-sans antialiased overflow-x-hidden">
      {/* Hero Section */}
      <section className="relative h-[65vh] flex items-center justify-center bg-black overflow-hidden">
        <img src={HeroImg} alt="Tennis Clinics" className="absolute inset-0 w-full h-full object-cover opacity-60 scale-105" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-transparent to-black/70" />
        <div className="relative z-10 text-center text-white max-w-4xl mx-auto px-6 animate-fade-in">
          <h1 className="text-5xl md:text-7xl font-extrabold mb-6 tracking-tight drop-shadow-2xl">
            Clinics & <br /><span className="text-primary italic">Expert Training</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 font-medium drop-shadow-lg text-gray-200">
            Master specialized strokes and strategy in Helsinki
          </p>
        </div>
      </section>

      <LessonsCards />
      <HowItWorks />
      <CourseDetails />

      <footer className="py-12 bg-navy text-white text-center border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6">
          <p className="opacity-60 text-sm">© 2025 Alain Brouillaud | Spin Doctor Tennis. All rights reserved.</p>
        </div>
      </footer>
    </main>
  );
}
